import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 22,
    marginTop: 12,
    alignSelf: "center",
    minHeight: 350,
    width: 350,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 20,
  },
  iconSelect: {
    width: 20,
    height: 20,
  },
  contentSelect: {
    alignSelf: "center",
    width: "40%",
    textAlign: "center",
    alignItems: "center",
  },

  textAmount: {
    flex: 0.5,
    textTransform: "uppercase",
    fontSize: 14,
    color: "#A0A0A0",
    fontWeight: "bold",
    marginTop: 35,
    textAlign: "left",
  },

  txtSaldoReal: {
    fontWeight: "400",
    color: "#656565",
  },

  containerPreco: {
    flexDirection: "row",
    display: "flex",
  },

  price: {
    textAlign: "center",
    fontSize: 12,
    marginTop: 15,
  },

  contentBtn: {
    marginTop: 12,
    alignSelf: "center",
    alignItems: "center",
    paddingHorizontal: 4,
    width: 320,
  },
  btn: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
    textTransform: "uppercase",
  },
  numberInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#ccc",
  },
  contentPurchase: {
    paddingHorizontal: 0,
    marginTop: 12,
  },
  titlePurchase: {
    textTransform: "uppercase",
    textAlign: "left",
    marginBottom: 4,
  },
  contentPurchaseAmount: {
    flexDirection: "row",
    justifyContent: "center",
  },

  pickerAtivos: {
    marginTop: 10,
    maxWidth: 350,
    fontSize: 16,
    backgroundColor: "#FFFFFF",
    borderWidth: 2,
    borderColor: "#DDD",
    borderRadius: 5,
    padding: 10,
    alignSelf: "center",
    color: "#444444",
  },

  containerMeuSaldo: {
    flex: 0.5,
    marginBottom: 40,
    marginTop: 20,
  },

  txtMeuSaldo: {
    textAlign: "left",
    textTransform: "uppercase",
  },

  containerMsgAntesCont: {
    padding: 15,
    marginTop: 50,
    marginBottom: 50,
  },
});

export default styles;
